import { CTNumFmt } from '../model-pb/ct-num-fmt-sml';
import { DEFAULT_NUMBER_FORMAT_CODE } from '../format-code';

/**
 * 表格默认数值格式
 */
export const DEFAULT_NUMBER_FORMAT = new CTNumFmt({
    numFmtId: 0,
    formatCode: DEFAULT_NUMBER_FORMAT_CODE,
});
